/*
  Fish hook
  by Poly by Google [CC-BY] (https://creativecommons.org/licenses/by/3.0/)
  via Poly Pizza (https://poly.pizza/m/3xxRFD2brcq)
  
  Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import { useEffect, type JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      Hook: Mesh
    }
    materials: {
      ['default']: MeshStandardMaterial
    }
  }

export default function FishingHook(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('./models/fishing-hook.glb') as GLTFResult

  useEffect(() => {
    materials['default'].color.set('gray')
    materials['default'].metalness = 0.8
    materials['default'].roughness = 0.2
  }, [materials])

  return (
    <mesh
      {...props}
      dispose={null}
      geometry={nodes.Hook.geometry}
      material={materials['default']}
    />
  )
}

useGLTF.preload('./models/fishing-hook.glb')
